import { render, staticRenderFns } from "./DesignImport.vue?vue&type=template&id=4ea87b7a&scoped=true&"
import script from "./DesignImport.vue?vue&type=script&lang=js&"
export * from "./DesignImport.vue?vue&type=script&lang=js&"
import style0 from "./DesignImport.vue?vue&type=style&index=0&id=4ea87b7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea87b7a",
  null
  
)

export default component.exports